// Flow types automatically removed

import { Fragment } from 'react';
import { FormattedMessage } from 'dibs-react-intl';
import styles from './styles/FormStepInspiration.scss';
import { BackButton } from './BackButton.jsx';
import { PictureSelection } from './fields/PictureSelection.jsx';
import { MatchmakerButton } from './fields/MatchmakerButton.jsx';
import { ErrorMessage } from './fields/ErrorMessage.jsx';
import { LastElement } from './fields/LastElement.jsx';
export const photoPaths = [
    'https://a.1stdibscdn.com/assets/trade/matchmaker/style_selection_1.jpg',
    'https://a.1stdibscdn.com/assets/trade/matchmaker/style_selection_2.jpg',
    'https://a.1stdibscdn.com/assets/trade/matchmaker/style_selection_3.jpg',
    'https://a.1stdibscdn.com/assets/trade/matchmaker/style_selection_4.jpg',
    'https://a.1stdibscdn.com/assets/trade/matchmaker/style_selection_5.jpg',
    'https://a.1stdibscdn.com/assets/trade/matchmaker/style_selection_6.jpg',
    'https://a.1stdibscdn.com/assets/trade/matchmaker/style_selection_7.jpg',
    'https://a.1stdibscdn.com/assets/trade/matchmaker/style_selection_8.jpg',
    'https://a.1stdibscdn.com/assets/trade/matchmaker/style_selection_9.jpg',
];
export const FormStepInspiration = props => (
    <Fragment>
        <div className={styles.item}>
            {photoPaths.map((path, index) => (
                <PictureSelection
                    checkmarkNeeded="true"
                    onChange={props.updatePhotoSelection}
                    imageInput={path}
                    key={`photo-select-${index}`}
                    selectedStyle={styles.selected}
                    originalStyle={styles.original}
                    checked={props.selectedPhotos.includes(path)}
                />
            ))}
        </div>
        <ErrorMessage errors={props.errors.selectedPhotos} />
        <MatchmakerButton
            classNames={styles.ctaNext}
            onClick={props.onPageChange}
            style={styles.ctaNext}
            buttonName={
                <FormattedMessage
                    id="abt.matchmaker.formStepInspiration.nextButton"
                    defaultMessage="next"
                />
            }
            fullWidth
        />
        <LastElement style={styles.ctaNext} child={<BackButton onClick={props.onPageBack} />} />
    </Fragment>
);
